module.exports = __webpack_public_path__ + "static/media/contract-manufacturing.a73d5a46.svg";